import { colorPalette } from "../../../shared/utils/constants";

export const customStyles = {
  text: {
    width: "100%",
    display: "flex",
    fontFamily: "'Bebas Neue', sans-serif",
    justifyContent: "center",
    flexWrap: "wrap",
    color: colorPalette.sectionTitle,
  },
  card: {
    maxWidth: 400,
    boxShadow: 5,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  cardHeading: {
    color: colorPalette.sectionTitle,
    fontFamily: "'Bebas Neue', sans-serif",
  },
  seeMoreButton: {
    marginTop: "auto",
    color: colorPalette.sectionTitle,
    textDecoration: "none",
    // fontWeight: "600",
    textTransform: "none",
    alignSelf: "flex-start",
    padding: "8px 0",
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "rgba(4, 100, 100, 0.08)",
      color: colorPalette.headerBackground,
    },
  },
  shortDescription: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
  },
};
